import {browserConfirm, browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import authMiddleware from './authMiddleware'
import maintenanceHandlerMiddleware from './maintenanceHandlerMiddleware'
import orderInterruptedMiddleware from './orderInterruptedMiddleware'
import sentryTransaction from './sentryMiddleware'

import type {Middleware, SerializableStateInvariantMiddlewareOptions} from '@reduxjs/toolkit'

export const DefaultMiddlewareOptions: {
    serializableCheck: SerializableStateInvariantMiddlewareOptions
} = {
    serializableCheck: {
        ignoredActions: [browserConfirm.type],
    },
}

const Middlewares: Middleware[] = [
    authMiddleware,
    maintenanceHandlerMiddleware,
    orderInterruptedMiddleware,
    browserEventEmitter,
    sentryTransaction,
]

export default Middlewares
